
// a notification inbox component

// a sort function that sorts notifications by issueTime
const AUTHOR_ORDER = ['Admin','System'];
const sortNotifications = (a, b) => {
  if (a.issueTime < b.issueTime) {
    return 1;
  }
  if (a.issueTime > b.issueTime) {
    return -1;
  }
  return 0;
};

// use sortNotifications to sort notifications
const sort = (notifications) => notifications.sort(sortNotifications);

const NotificationStore = class extends EventTarget {
  constructor(localStorageKey) {
    super();
    this.localStorageKey = localStorageKey;
    this._readStorage();
    this._save();
    // handle notifications edited in another window
    window.addEventListener('storage', () => {
      console.log('storage event');
      this._readStorage();
      this._save();
    }, false);

    // GETTER methods
    this.get = id => this.notifications.find(notification => notification.id === id);
    this.isAllCompleted = () => this.notifications.every(notification => notification.completed);
    this.hasUnread = () => this.notifications.some  (notification => notification.read === false || notification.read === undefined);
    this.all = filter =>
      (filter === 'inbox') ? sort(this.notifications.filter(notification => (!notification.time || notification.time === 0) && !notification.notInbox)) : 
        (filter === 'active') ? sort(this.notifications.filter(notification => !notification.completed)) :
          (filter === 'completed') ?sort(this.notifications.filter(notification => notification.completed)) :
            (filter === 'popup') ? sort(this.notifications.filter(notification => notification.popup)) :
              (filter === 'detail') ? sort(this.notifications.filter(notification => notification.detached)) :
                sort(this.notifications);
    // save notifications every minute
    window.setInterval(this._save.bind(this), 60000);
  }
  _readStorage() {
    this.notifications = JSON.parse(window.localStorage.getItem(this.localStorageKey) || '[]', 
      (key, value) => 
        (key === 'issueTime' || key === 'expTime') ?
          new Date(value) : value);

    this.dispatchEvent(new CustomEvent('load'));
  }
  _save() {
    // remove all expired notifications
    this.notifications = this.notifications.filter(notification => {
      if (notification.expTime) {
        return notification.expTime > new Date();
      }
      return true;
    });
    window.localStorage.setItem(this.localStorageKey, JSON.stringify(this.notifications));
    this.dispatchEvent(new CustomEvent('save'));
  }
  load() {
    this._readStorage();
    this._save();
  }
  // MUTATE methods
  /**
   * add a notification to the store
   * 
   * @param {import('./notification-item').NotificationStoreItem} notification 
   * @returns {import('./notification-item').NotificationStoreItem}
   */
  add(notification) {
    // random unique id
    const randomId = () => Math.random().toString(36).slice(0, 10);  
    const id = notification.id || `id_${ Date.now()}_${  randomId()}!`;
    // check if notification already exists
    if (this.notifications.find(notification => notification.id === id)) {
      return null;
    }
    // popup should be false if type is 'info' or popup is set to false

    if (notification.type === 'info') {
      notification.popup = false;
    } else {
      notification.popup = true;
    }
    // add notification to the store
    this.notifications.push({ ...notification,
      popup: notification.popup,
      actions: notification.actions || [],
      active: false,
      read: notification.notInbox,
      detached: false,
      issueTime : notification.issueTime?  new Date(notification.issueTime*1000) : new Date(),
      // TODO: add never expire option
      expTime : notification.expTime?  new Date(notification.expTime*1000) : null,
      id });
    this._save();
    return { ...notification, 
      id }; 
  }
  exists(notification) {
   
    return this.notifications.some(obj =>
      // eslint-disable-next-line no-prototype-builtins
      Object.keys(notification).every(key => obj[key] === notification[key])
    );
  }

  /**
   * 
   * @param {NotificationStoreItem} param0 
   */
  remove({ id }) {
    this.notifications = this.notifications.filter(notification => notification.id !== id);
    this._save();
  }
  /**
   * togglePopup is used to toggle the popup
   * @param {NotificationStoreItem} param0
   * 
   * */
  togglePopup({ id },to) {
    this.notifications = this.notifications.map(notification => notification.id === id ? { ...notification,
      popup: to? to : !notification.popup } : notification);
    this._save();
  }

  toggleTimeout({ id },to) {
    this.notifications = this.notifications.map(notification => notification.id === id ? { ...notification,
      time: to? to : !notification.popup } : notification);
    this._save();
  }

  /**
   * expand and collapse notification item details panel
   * @param {NotificationStoreItem} param0 
   */
  toggleActive({id}) {
    this.notifications = this.notifications.map(notification => notification.id === id ? { ...notification,
      active : !notification.active } : notification);
    this._save();

  }
  toggleDetached({id}) {
    this.notifications = this.notifications.map(notification =>  ({ ...notification,
      detached : false }) );
    this.notifications = this.notifications.map(notification => (notification.id === id) ? { ...notification,
      detached : true } : notification);
    this._save();
  }
  detacheNext() {
    const sorted = sort(this.notifications);
    const index = sorted.findIndex(notification => notification.detached );
    if (index === -1 || index === sorted.length - 1) {
      return;
    }
    const next = sorted[index + 1];
    if (next) {
      this.toggleDetached(next);
    }
  }
  detachPrev() {
    const sorted = sort(this.notifications);
    const index = sorted.findIndex(notification => notification.detached );
    if (index === -1 || index === 0) {
      return;
    }
    const prev = sorted[index - 1];
    if (prev) {
      this.toggleDetached(prev);
    }
  }
  
  // TODO: implement this
  clearExpired() {
    this.notifications = this.notifications.filter(notification => !notification.completed);
    this._save();
  }
  update(notification) {
    this.notifications = this.notifications.map(t => t.id === notification.id ? notification : t);
    this._save();
  }
  toggleAllRead() {
    const read = true;
    this.notifications = this.notifications.map(notification => ({ ...notification,
      read }));
    this._save();
  }
  revert() {
    this._save();
  }
};
export default NotificationStore;